import { useState, useEffect } from 'react'
import { Table, Form, Button, InputGroup } from 'react-bootstrap'
import { FaTrash, FaPlus } from 'react-icons/fa'
import { toast } from 'react-toastify'
import { useParams } from '../../../Providers/ParamsProvider'
import AddNavBarElementModal from '../Modals/AddNavBarElementModal'
import LoadingSpinner from '../../../Components/Components/LoadingSpinner'
import useConfirmDelete from '../../../Hooks/useConfirmDelete'

const EMPTY_NEW_ITEM = {
    name: '',
    reDirectLink: '',
    isReDirectLinkDirectToEHandel: false,
}

const AdminPanelNavBar = () => {
    const { handleGetNavBarItems, handleDeleteNavBarItem } = useParams()
    const { requestDelete, confirmModal } = useConfirmDelete()
    const [navBarItems, setNavBarItems] = useState([])
    const [newItem, setNewItem] = useState(EMPTY_NEW_ITEM)
    const [isAdding, setIsAdding] = useState(false)
    const [showAddModal, setShowAddModal] = useState(false)
    const [isLoading, setIsLoading] = useState(false)


    useEffect(() => {
        const fetchNavBarItems = async () => {
            setIsLoading(true)
            const items = await handleGetNavBarItems()
            setNavBarItems(items)
            setIsLoading(false)
        }

        fetchNavBarItems()
    }, [])

    const refreshNavBarItems = async () => {
        const items = await handleGetNavBarItems(true) //wymuszamy pobranie z API, by zaciągnąć nowy element z nadanym Id
        setNavBarItems(items)
    }

    const handleNewItemChange = (field, value) => {
        setNewItem(prev => ({ ...prev, [field]: value }))
    }

    const handleAddItem = async () => {
        if (!newItem.name.trim() || !newItem.reDirectLink.trim()) {
            toast.warning('Uzupełnij nazwę i link przekierowania.')
            return
        }

        setIsAdding(true)
        try {
            const created = {
                id: Date.now(),
                name: newItem.name.trim(),
                reDirectLink: newItem.reDirectLink.trim(),
                isReDirectLinkDirectToEHandel: newItem.isReDirectLinkDirectToEHandel,
            }
            setNavBarItems(prev => [...prev, created])
            setNewItem(EMPTY_NEW_ITEM)
            toast.success('Dodano element paska nawigacji.')
        } catch (e) {
            console.log(e)
            toast.error('Błąd podczas dodawania elementu!')
        } finally {
            setIsAdding(false)
        }
    }

    const handleDeleteItem = async (id) => {
        const success = await handleDeleteNavBarItem(id)
        if (success) {
            setNavBarItems(prev => prev.filter(item => item.id !== id))
            toast.success('Usunięto element paska nawigacji.')
        } else {
            toast.error('Błąd podczas usuwania elementu!')
        }
    }

    if (isLoading) {
        return <LoadingSpinner />
    }
    return (<>
        {confirmModal}
        <AddNavBarElementModal
            show={showAddModal}
            onHide={() => setShowAddModal(false)}
            onAdded={refreshNavBarItems}
        />

        <h5 className='fw-semibold border-bottom pb-2 mb-3'>Elementy paska nawigacji</h5>
        <Table hover className='mb-4' responsive style={{ minWidth: '620px' }}>
            <thead>
                <tr>
                    <th style={{ width: '30%' }}>Nazwa</th>
                    <th style={{ width: '40%' }}>Link przekierowania</th>
                    <th className='text-center' style={{ width: '15%' }}>Wewnątrz platformy E-Handel</th>
                    <th className='text-end' style={{ width: '5%' }}></th>
                </tr>
            </thead>
            <tbody>
                {navBarItems.length === 0 && (
                    <tr>
                        <td colSpan={5} className='text-center text-muted py-3'>
                            Brak elementów paska nawigacji.
                        </td>
                    </tr>
                )}
                {navBarItems.map(item => (
                    <tr key={item.id}>
                        <td className='align-middle'>{item.name}</td>
                        <td className='align-middle text-break'>{item.reDirectLink}</td>
                        <td className='align-middle text-center'>
                            {item.isReDirectLinkDirectToEHandel ? 'Tak' : 'Nie'}
                        </td>
                        <td className='align-middle text-end'>
                            <Button
                                size='sm'
                                variant='outline-danger'
                                onClick={() => requestDelete('Czy na pewno usunąć element paska nawigacji?', () => handleDeleteItem(item.id))}
                                title='Usuń'
                            >
                                <FaTrash size={13} />
                            </Button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
        <div className='d-flex justify-content-end'>
            <button className='btn btn-primary' onClick={() => setShowAddModal(true)}>Dodaj element</button>
        </div>
    </>)
}

export default AdminPanelNavBar
